import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsTemplateService } from '../../../../services/forms-template.service';
import { AnagraficaService } from '../../../../services/anagrafica.service';
import { DxRadioGroupComponent } from 'devextreme-angular';

@Component({
  selector: 'app-input-radiogroup-el',
  templateUrl: './input-radiogroup-el.component.html',
  styleUrls: ['./input-radiogroup-el.component.css']
})
export class InputRadiogroupElComponent implements OnInit,OnChanges {

  @ViewChild('inputRadioGroup', { static: false }) inputRadioGroup: ElementRef<HTMLInputElement>;
  @ViewChild('inputRadioGroupDx', { static: false }) inputRadioGroupDx: DxRadioGroupComponent;
  //https://stackblitz.com/edit/angular-dynamic-form-builder?file=app%2Fdynamic-form-builder%2Fdynamic-form-builder.component.ts

  @Input() fileDataInput: any
  @Input() dataValue: boolean = false;
  @Input() dataInput: any;
  @Input() formGroup
  @Input() tabindex;
  @Input() isDX: boolean = true

  @Output() radioGroupEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() radioGroupInitialized: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno

  radiovalue: any
  radio;
  optionData: any = [];
  queryString = ''
  filterOdata: string = '';
  checkQueryStringError: boolean = false;

  layout: string = "horizontal"
  valueExpr: any;
  displayExpr: any;
  constructor(

    private formTemplateService: FormsTemplateService,
    private anagraficaService: AnagraficaService
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    console.log('cambiiiiiiiiiiiiiiiiiiiiiiiiii',changes)
    if(changes.dataValue&&changes.dataValue.currentValue===null){
      if(this.inputRadioGroupDx)this.inputRadioGroupDx.instance.reset()
    }
  }

  ngOnInit() {
    console.log('dddddddddddd->', this.dataValue)
    let dataField = this.fileDataInput.dataField
    this.radiovalue = this.dataInput[dataField];

    this.radio = this.fileDataInput.radioGroup

    this.layout = this.radio.layout;

    this.valueExpr = this.radio.valueExpr;
    this.displayExpr = this.radio.displayExpr;

    this.getDataSource()
  }

  async getDataSource(data?) {

    if (typeof data == 'undefined') {
      data = this.radio
    }
    this.optionData = [];
    this.queryString = typeof data.queryString != 'undefined' ? data.queryString : ''



    if (data.static) {
      let dataformService = this.formTemplateService.getDati(data.dataSource)
      if (typeof dataformService != 'undefined') {
        this.optionData = this.optionData.concat(dataformService)
      } else {
        if (data.items) {
          this.optionData = this.optionData.concat(data.items)
        }
      }

      return
    }

    let dataS;

    this.buildAndTestQueryString()


    let theQueryStingOdata = '';
    const options = {};


   

    if (this.filterOdata != '') {
      options['$filter'] = this.filterOdata;

    }



    let firstCaratter = this.queryString && this.queryString.startsWith('?') ? '&' : '?';

    for (let x in options) {

      if (x == '$filter')
        theQueryStingOdata += `${x}=${options[x]}`
      else
        theQueryStingOdata += `${x}=${options[x]}&`
    }

    theQueryStingOdata = firstCaratter + theQueryStingOdata;


    if (!this.checkQueryStringError) {
      dataS = await this.anagraficaService.getElenco(data.dataSource, '', this.queryString, theQueryStingOdata)

      if (dataS['items']) {
        dataS = dataS['items']
      } else {
        dataS = dataS
      }



      if (dataS) {
        this.optionData = dataS
      }

    }


  }

  buildAndTestQueryString() {


    if (this.queryString != '') {

      let queryString = this.queryString;

      // crea un'espressione regolare per cercare "$filter=(...)"
      let regexFilter = /\$filter=\([^]*\)*/;

      // Esegui la ricerca nella stringa
      let matchFilter = queryString.match(regexFilter);

      // Verifica se c'è una corrispondenza
      if (matchFilter) {

        let parteSenzaFilter = matchFilter[0].replace(/\$filter=/, '');
        //rimuovere solo la parte ?$filter= 
        console.log("Trovato:", parteSenzaFilter);

        if (parteSenzaFilter.includes('$')) {
          for (let x in this.dataInput) {
            if (queryString.includes(x)) {
              let regex = new RegExp('\\$' + x + '\\b', 'g');
              parteSenzaFilter = parteSenzaFilter.replace(regex, this.dataInput[x]);
              //queryString = queryString.replace('$' + x, this.dataInput[x]);

            }
          }

        }

        this.filterOdata = parteSenzaFilter;

        queryString = queryString.replace(regexFilter, '');

        //Pezzottissimo
        if (queryString == '?)') {
          queryString = ''
        }
        //............
        this.queryString = queryString;
      }


      if (this.queryString.includes('$')) {
        for (let x in this.dataInput) {
          if (queryString.includes(x)) {
            let regex = new RegExp('\\$' + x + '\\b', 'g');
            if (typeof this.dataInput[x] == 'undefined') {
              this.checkQueryStringError = true;
              return
            }

            if (!this.dataInput[x]) {
              this.checkQueryStringError = true;
              return
            }

            queryString = queryString.replace(regex, this.dataInput[x]);


          }
        }
        this.checkQueryStringError = false;
        this.queryString = queryString
      }
    }
  }


  onRadioGroupChange(ev, radioGroup) {

    const radioGroupValue = radioGroup.value;
    if (radioGroupValue != '') {
      let c = this.formGroup.get(this.fileDataInput.dataField)
      c.setValue(radioGroupValue)

    }

    let event = {
      name: 'radioGroupChange',
      dataField: this.fileDataInput.dataField,
      component: ev.component,
      value: radioGroupValue,
      element: ev.element
    }
    this.radioGroupEvent.emit(event);



  }

  onInitializzedRadioGroupDX(event){
    event.nativeElement = event.element;
    event.dxComponent = event.component;
    event.editorComponent = this;
    event.id = this.fileDataInput.dataField  
    this.radioGroupInitialized.emit(event);
   
  }
}



